var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationPendingInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration-pending-info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector-1458",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8388 35.7178C29.5376 44.8986 28.01 54.8044 28.01 54.8044L28.8014 78.0499L28.9565 94.5286C28.9565 94.5286 30.5256 120.96 30.5528 123.85L30.8916 147.465C31.038 156.831 35.5856 164.227 41.0689 163.951L127.286 161.173C132.751 161.03 137.137 153.379 137.107 144.009L136.054 32.229C135.888 22.8307 131.341 15.4675 125.877 15.7765L39.6408 18.5551C34.1753 18.6615 29.7892 26.3457 29.8388 35.7178Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1457",
    d: "M28.0783 61.9642C28.0777 61.8986 28.0771 61.833 28.0765 61.7674C28.1354 55.0392 28.3777 48.3052 28.9259 41.5941C29.3655 36.3302 30.0277 30.8951 31.964 26.5673C34.2004 21.6392 37.4075 19.5179 41.5609 17.5631C45.8091 15.5637 49.094 16.6642 52.8674 16.9363C69.7764 18.1961 86.7197 18.7657 103.646 17.4985C110.815 16.9722 118.002 16.0844 125.198 16.2135C130.927 16.2914 140.024 14.8827 142.489 25.5324C143.34 29.311 143.318 33.4459 143.274 37.4831C142.813 75.0336 142.372 112.616 141.931 150.166C141.9 153.35 141.769 156.799 140.446 159.139C139.022 161.58 134.644 162.082 134.644 162.082C134.644 162.082 70.6506 167.228 38.6337 169.834C37.6356 169.899 36.5967 169.966 35.693 169.24C34.1107 167.88 33.6924 164.58 33.4614 161.7C32.3755 148.118 31.2895 134.537 30.407 120.916",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1456",
    d: "M44.6061 85.5339L119.261 81.8751",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1455",
    d: "M77.8034 37.7037L115.202 35.4125",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1454",
    d: "M47.1816 101.887L102.645 103.191",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1453",
    d: "M97.5322 124.013L45.2289 124.803",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1452",
    d: "M96.8818 146.145L44.5785 146.934",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1451",
    d: "M118.133 57.6374L44.5781 60.3374",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1611",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7616 52.1206C53.0126 57.2518 46.8722 61.8342 40.4078 65.8175C38.6674 67.1297 36.7055 68.0493 34.6363 68.5228C32.2685 68.7558 29.8914 68.1889 27.8252 66.8984C27.8252 66.8984 27.7427 66.8989 27.7187 66.8216C27.1629 66.5281 26.6187 66.1958 26.0744 65.8506C20.1577 62.0143 14.9257 56.3673 12.6788 49.2315C12.2742 47.9203 11.9666 46.5758 11.7589 45.2108C11.2027 41.2658 11.4075 37.238 12.3601 33.3868C13.6988 28.1883 16.0325 23.3622 19.2065 19.2289C22.9169 14.0025 27.9527 10.0904 33.6851 7.981C35.9242 7.21654 38.2513 6.80308 40.597 6.75292C47.6686 6.60786 54.8402 9.37861 61.1451 13.0836C62.3648 13.7815 63.5498 14.5499 64.6951 15.3854C66.7979 16.8182 68.6461 18.6568 70.1498 20.8117C77.2879 31.8028 66.0639 45.2123 58.7616 52.1206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1610",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2149 15.2645C46.1797 13.5762 52.7758 14.8068 57.8706 18.1424C59.9319 19.4912 61.7535 21.1872 63.1798 23.1601C66.3552 27.5507 67.6763 33.0608 67.3737 38.4212C67.0711 43.7817 65.2174 48.9996 62.5291 53.7121C60.4697 57.322 57.8709 60.7147 54.4783 63.2196C51.0856 65.7245 46.8349 67.2884 42.5848 67.0123C38.8993 66.7734 35.4323 65.1864 32.4357 63.1159C25.8151 58.5412 21.1523 51.4525 19.528 43.7404C18.2642 37.7399 18.8973 31.1372 22.4657 26.0497C26.4112 20.4245 33.1745 17.4883 39.6368 15.4378C39.8289 15.377 40.0213 15.3192 40.2149 15.2645Z",
    fill: "#F08E0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1609",
    d: "M39.3455 17.2372C24.7824 18.645 14.0969 31.1757 15.4789 45.2243C16.8148 58.8089 28.9799 68.926 43.1092 68.2053C57.6978 67.1283 71.3766 51.7771 70.3413 37.7526C69.3737 24.8208 55.3435 16.0562 39.3455 17.2372Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vector-1608"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1423 26.664C34.3923 29.664 40.6423 43.539 44.236 50.1015C45.1736 46.1952 47.1425 36.9765 47.5175 31.3515C47.9863 24.3202 42.8298 22.914 38.1423 26.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5488 54.789C40.2988 52.164 43.9238 53.0703 45.6425 53.8515C49.3925 55.2578 46.58 59.9453 43.7675 61.3515C40.955 62.7578 38.6113 58.0703 39.5488 54.789Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vector-1607"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0798 23.8515C35.3298 26.8515 41.5798 40.7265 45.1735 47.289C46.1111 43.3827 48.08 34.164 48.455 28.539C48.9238 21.5077 43.7673 20.1015 39.0798 23.8515Z",
    stroke: "#70758F",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4863 51.9765C41.2363 49.3515 44.8613 50.2578 46.58 51.039C50.33 52.4453 47.5175 57.1328 44.705 58.539C41.8925 59.9453 39.5488 55.2578 40.4863 51.9765Z",
    stroke: "#70758F",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationPendingInfo);
export default __webpack_public_path__ + "static/media/illustration-pending-info.3f6587f59cb81d2a1a499add5cb5438e.svg";
export { ForwardRef as ReactComponent };